module.exports = __webpack_public_path__ + "img/h12-min.6b2a87f0.png";